/**
 * Shared saved-search constants and the entry shape.
 *
 * This module used to also house a localStorage-backed store
 * (`createSavedSearchStore`) shared by the Search and Track pages, along with
 * its repair machinery and config/store types. That persistence has moved to
 * the backend UserPreference API (see `useUserPreferences`) — exactly the
 * migration the original TEMPORARY-storage note here anticipated ("Long term
 * these move into the users DynamoDB table ... this module ... is deleted
 * outright"). Only the pieces still used by the backend hooks and the Track
 * help tip remain.
 */

import type { TranslateFn } from 'src/i18n/shim/useTranslation';

/** Default number of saved searches kept before the oldest is evicted. */
export const DEFAULT_MAX_SAVED_SEARCHES = 5;

/**
 * Builds the Save Search info-tip copy. `TrackFilters` is the sole renderer today; this stays
 * here rather than moving next to it so the wording has one home if a second surface needs it.
 */
export const saveSearchHelpText = (t: TranslateFn): string =>
  t('save-search-help-text', {
    max: DEFAULT_MAX_SAVED_SEARCHES,
    next: DEFAULT_MAX_SAVED_SEARCHES + 1,
  });

/** A single saved search entry, generic over the state each page persists. */
export interface SavedSearchEntry<TState> {
  id: string;
  label: string;
  state: TState;
  savedAt: number;
}
